<template>
  <div class="my-16">
    <v-card class="ma-0 pa-0">
      <v-carousel
        hide-delimiters
        v-if="items"
        continuous
        height="100%"
        :show-arrows="showArrows"
      >
        <v-carousel-item
          v-for="(item,i) in items"
          :key="i"
          :src="item.src"
          height="100%"
        ></v-carousel-item>
      </v-carousel>
      <v-alert class="" elevation="16" color="rgba(0,0,0,0)">
        <h1>
          <a :href="headerLink.href" class="display-1 font-weight-bold text-decoration-none">{{headerLink.name}}</a>
        </h1>
        <div class="mt-8 mb-4" v-if="tags">
          <v-chip class="mr-2 mb-2" v-for="(tag, index) in tags" :key="index">{{tag}}</v-chip>
        </div>
        <div v-if="descriptions" class="mb-4">
          <p class="font-weight-regular" v-for="(description, index) in descriptions" :key="index" v-html="description">
          </p>
        </div>
        <v-alert v-if="points" color="rgba(0,0,0,0.1)" class="mb-8">
          <li v-for="(point, index) in points" :key="index" v-html="point" class="font-weight-regular">
          </li>
        </v-alert>
        <div v-if="links">
          <strong v-for="(link, index) in links" :key="index">
            <v-btn :href="link.href" class="mr-2 mb-2" large outlined>
              <h3>
              {{link.name}}
              </h3>
            </v-btn>
          </strong>
        </div>
      </v-alert>
    </v-card>
  </div>
</template>
<script lang="ts">
import { defineComponent, PropType } from 'vue'

export interface ILink {
  name?: string;
  href?: string;
}

export default defineComponent({
  name: "ProjectComponent",
  components: {
  },
  props: {
    headerLink: {
      type: Object as PropType<ILink>,
      required: false,
      default: undefined,
    },
    tags: {
      type: Array as PropType<Array<string>>,
      required: false,
      default: undefined,
    },
    descriptions: {
      type: Array as PropType<Array<string>>,
      required: false,
      default: undefined,
    },
    points: {
      type: Array as PropType<Array<string>>,
      required: false,
      default: undefined,
    },
    links: {
      type: Array as PropType<Array<ILink>>,
      required: false,
      default: undefined,
    },
    imgSrc: {
      type: String,
      required: false,
      default: undefined,
    },
    imgSrcs: {
      type: Array,
      required: false,
      default: undefined,
    },
  },

  computed: {
    showArrows(): boolean {
      return this.items?.length > 1 ? true : false;
    },
    items(): Array<any> {
      let items = [];
      if (this.imgSrcs?.length) {
        items = this.imgSrcs?.map((i: any) => {
          return {
            src: i
          }
        })
      } else if (this.imgSrc) {
        items.push({
          src: this.imgSrc
        });
      }
      return items;
    }
  }
});
</script>
